export const encyclopediaIt = {
  // Shared
  'encyclopedia.lockAria': 'Bloccato — sblocca per leggere',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': "L'Enciclopedia",
  'encyclopedia.page.seoDescription':
    'Scruta il grimorio vivente di Grymwyrd — mostri, incantesimi, specie, oggetti, luoghi e altro ancora.',
  'encyclopedia.page.heading': "L'Enciclopedia",
  'encyclopedia.page.subtitle': 'Il grimorio vivente di ogni orrore, incantesimo e leggenda di Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Cerca {plural}…',
  'encyclopedia.page.searchAria': 'Cerca {plural}',
  'encyclopedia.page.clearSearch': 'Cancella ricerca',
  'encyclopedia.page.systemNotLivePrefix': 'Il Velo non si è ancora schiuso per',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Nessun sapere legato a questo rito ha trapelato — il suo grimorio attende oltre il buio.',
  'encyclopedia.page.returnToAllSystems': 'Torna a tutti i sistemi',
  'encyclopedia.page.settingNotLivePrefix': 'Le terre di',
  'encyclopedia.page.settingNotLiveSuffix':
    ' vengono ancora rilevate — le sue voci non sono ancora legate al contesto. Finché i cartografi non terminano, qui nulla risponde.',
  'encyclopedia.page.returnToAllRealms': 'Torna a tutti i regni',
  'encyclopedia.page.filteringBy': 'Filtrando per',
  'encyclopedia.page.filterSystem': 'sistema "{label}"',
  'encyclopedia.page.filterCanon': 'strato canonico "{label}"',
  'encyclopedia.page.filterSetting': 'contesto "{label}"',
  'encyclopedia.page.canonNote': 'Lo strato canonico si applica una volta che le entità sono etichettate nell\'API (vedi _docs/13). ',
  'encyclopedia.page.clear': 'Cancella',
  'encyclopedia.page.hide': 'Nascondi',
  'encyclopedia.page.filter': 'Filtra',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Sblocca {name} (contenuto Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Visualizza voce {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Paginazione ({position})',
  'encyclopedia.grid.prev': 'Prec',
  'encyclopedia.grid.next': 'Succ',
  'encyclopedia.grid.pageOf': 'Pagina {page} di {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} risultati',
  'encyclopedia.grid.scrying': 'Scrutando gli archivi…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Ordina decrescente',
  'encyclopedia.grid.sortAscAria': 'Ordina crescente',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Modalità di visualizzazione',
  'encyclopedia.grid.gridViewAria': 'Vista griglia',
  'encyclopedia.grid.listViewAria': 'Vista elenco',
  'encyclopedia.grid.jumpToLetterAria': 'Vai alla lettera',
  'encyclopedia.grid.all': 'Tutto',
  'encyclopedia.grid.letterSymbolAria': 'Voci che iniziano con un numero o simbolo',
  'encyclopedia.grid.letterAria': 'Voci che iniziano con {letter}',
  'encyclopedia.grid.emptyTitle': "L'Archivio è Silenzioso",
  'encyclopedia.grid.emptyForLetter': 'Nessun {plural} reca un nome che inizi con "{letter}".',
  'encyclopedia.grid.emptyAll': 'Nessun {plural} risponde al tuo richiamo.',
  'encyclopedia.grid.turningPages': 'Sfogliando le pagine…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (nessun artwork)',
  'encyclopedia.entityImage.noVision': 'Nessuna Visione',

  // FacetSidebar
  'encyclopedia.facets.all': 'Tutto',
  'encyclopedia.facets.soon': 'Presto',
  'encyclopedia.facets.navAria': 'Filtri per tipo di entità',
  'encyclopedia.facets.clearAll': 'Cancella tutti i filtri',
  'encyclopedia.facets.lorebook': 'Grimorio Narrativo',
  'encyclopedia.facets.gameSystem': 'Sistema di Gioco',
  'encyclopedia.facets.canonLayer': 'Strato Canonico',
  'encyclopedia.facets.setting': 'Contesto',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Scruta il Velo',
  'encyclopedia.globalSearch.placeholder': 'Cerca mostri, incantesimi, luoghi, sapere…',
  'encyclopedia.globalSearch.queryAria': 'Query di ricerca',
  'encyclopedia.globalSearch.loading': 'Scrutando…',
  'encyclopedia.globalSearch.empty': 'Nulla si muove nel buio per "{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Contenuto Grymwyrd — sblocca per leggere',
  'encyclopedia.lockBadge.label': 'Bloccato',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Contenuto bloccato',
  'encyclopedia.lockedGate.defaultTitle': 'Questo sapere è sigillato',
  'encyclopedia.lockedGate.body':
    "Il bestiario di Grymwyrd, i suoi incantesimi e le sue leggende sono legati al Cataclisma di Grymwyrd. Il canone SRD aperto rimane gratuito — ma per camminare nel crepuscolo eterno stesso, reclama il libro.",
  'encyclopedia.lockedGate.unlockCta': 'Sblocca Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Già un sostenitore? Accedi',
  'encyclopedia.lockedGate.backerNote':
    'I sostenitori che hanno promesso per Grymwyrd già possiedono questo — accedi per sbloccarlo sul tuo account.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — lanciato {total}',
  'encyclopedia.table.noRowMatched': 'Nessuna riga corrisponde a {total}.',
  'encyclopedia.table.loading': 'Dispiegando la tabella…',
  'encyclopedia.table.error': 'Questa tabella non ha potuto essere tracciata.',
  'encyclopedia.table.roll': 'Lancia {formula}',
  'encyclopedia.table.lastRoll': 'Ultimo lancio: {value}',
  'encyclopedia.table.noMatchingRow': ' · nessuna riga corrispondente',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Voce',
  'encyclopedia.detail.addedToCampaign': 'Aggiunto alla tua campagna.',
  'encyclopedia.detail.addError': 'Impossibile raggiungere il forziere della campagna. Riprova più tardi.',
  'encyclopedia.detail.unknownType': 'Tipo di voce sconosciuto.',
  'encyclopedia.detail.seoDescription': '{name} — un {label} nell\'Enciclopedia di Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Breadcrumb',
  'encyclopedia.detail.breadcrumbRoot': 'Enciclopedia',
  'encyclopedia.detail.sourceVersionAria': 'Versione sorgente',
  'encyclopedia.detail.versionConsolidated': 'Consolidato',
  'encyclopedia.detail.versionBook': 'Libro Specifico',
  'encyclopedia.detail.removeBookmarkAria': 'Rimuovi segnalibro',
  'encyclopedia.detail.addBookmarkAria': 'Aggiungi segnalibro',
  'encyclopedia.detail.bookmarked': 'Segnalibrato',
  'encyclopedia.detail.bookmark': 'Segnalibro',
  'encyclopedia.detail.addToCampaign': 'Aggiungi alla Campagna',
  'encyclopedia.detail.sealedTitle': '{name} è sigillato',
  'encyclopedia.detail.bookVariantNote':
    'Visualizzando il record consolidato; il testo variante per libro apparirà qui una volta che le edizioni dei libri saranno collegate.',
  'encyclopedia.detail.tablistAria': 'Sezioni della voce',
  'encyclopedia.detail.tab.lore': 'Sapere',
  'encyclopedia.detail.tab.stats': 'Statistiche',
  'encyclopedia.detail.tab.gallery': 'Galleria',
  'encyclopedia.detail.tab.relations': 'Relazioni',
  'encyclopedia.detail.tab.discussions': 'Discussioni',
  'encyclopedia.detail.tab.claims': 'Affermazioni dei Giocatori',
  'encyclopedia.detail.loading': 'Risvegliando la voce…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Scavando il sapere…',
  'encyclopedia.lore.empty': 'Le storie di questa voce rimangono non scritte.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Leggendo le rune…',
  'encyclopedia.stats.empty': 'Nessun meccanismo è registrato per questa voce.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Sviluppando le visioni…',
  'encyclopedia.gallery.emptyTitle': 'Nessuna Visione Ancora',
  'encyclopedia.gallery.emptyBody': 'Nessuna opera è stata legata a questa voce. Contribuisci una nella Vault.',
  'encyclopedia.gallery.artworkAlt': 'Artwork dell\'entità',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Raccogliendo i sussurri…',
  'encyclopedia.discussions.emptyTitle': 'Silenzio nelle Aule',
  'encyclopedia.discussions.emptyBody': 'Sii il primo a discutere di questa voce con i tuoi compagni erranti.',
  'encyclopedia.discussions.startCta': 'Avvia una Discussione',
  'encyclopedia.discussions.untitledThread': 'Thread senza titolo',
  'encyclopedia.discussions.byAuthor': 'di {author}',
  'encyclopedia.discussions.replyCount': '{count} risposte',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'La tua affermazione è stata registrata per la revisione.',
  'encyclopedia.claims.recordError': 'Gli scribi non hanno potuto registrare la tua affermazione. Riprova più tardi.',
  'encyclopedia.claims.loading': 'Consultando il canone…',
  'encyclopedia.claims.emptyTitle': 'Nessuna Affermazione del Giocatore Ancora',
  'encyclopedia.claims.emptyBody': 'Nessun errante ha ancora tessuto la sua leggenda in questa voce.',
  'encyclopedia.claims.claimCta': 'Reclama questo',
  'encyclopedia.claims.signInCta': 'Accedi per fare un\'affermazione',
  'encyclopedia.claims.untitledClaim': 'Affermazione senza titolo',
  'encyclopedia.claims.byAuthor': 'di {author}',
  'encyclopedia.claims.addCta': 'Aggiungi la tua affermazione',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Questa Voce',
  'encyclopedia.relations.relationLabel': 'Relazione {index}',
  'encyclopedia.relations.kindredLabel': 'Affine {index}',
  'encyclopedia.relations.loading': 'Tracciando i fili del destino…',
  'encyclopedia.relations.hintIntro': 'Clicca un nodo per viaggiare verso quella voce. I fili mostrati sono',
  'encyclopedia.relations.hintCanonical': ' relazioni canoniche.',
  'encyclopedia.relations.hintKindred': ' affini dello stesso tipo.',
}
